var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameParticipantLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: aqua;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #3a3a3a;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.8,28.1h10.4c6.9,0,12.5,5.6,12.5,12.5v2.1c0,2.3-1.9,4.2-4.2,4.2H11.5c-2.3,0-4.2-1.9-4.2-4.2v-2.1c0-6.9,5.6-12.5,12.5-12.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25,
    cy: 15.7,
    r: 12.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.9,0v49.8H0V0h49.8M50.9-.9H-.9v51.8h51.8V-.9h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameParticipantLine);
export default __webpack_public_path__ + "static/media/Game_participant_line.9f277a0734e91865d56f5ade4621a041.svg";
export { ForwardRef as ReactComponent };